console.log("campaign-collection-alpine.js");
document.addEventListener("alpine:init", () => {
  const { apiUrl, acceptedLanguage, apiKey, xAppid } = theme.emailSubscription;
  console.log("alpine init");

  Alpine.data("CampaignCollection", () => ({
    showPopup: false,
    loading: false,
    showStep: "subscription",
    email: "",
    disclaimerChecked: false,
    multiple1Id: "",
    multiple1Value: [],
    multiple1Overwrite: false,
    errMsg: "",

    onSubscribeBtnClick(id, value, overwrite) {
      console.log("onSubscribeBtnClick");
      this.setShowPopup();
      this.setMultiple1Info(id, value, overwrite);
    },
    setShowPopup() {
      this.email = "";
      this.showStep = "subscription";
      this.showPopup = true;
    },
    setMultiple1Info(id, value, overwrite) {
      this.multiple1Id = id;
      this.multiple1Value = value.split(",").map(Number);
      this.multiple1Overwrite = overwrite;
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
      this.showStep = "subscription";
      this.email = "";
    },

    async submitEmailForm() {
      this.errMsg = "";

      // Validation
      const isEmailValid = validateEmail(this.email);
      if (!this.disclaimerChecked) {
        this.errMsg =
          "Please agree to the Privacy Policy and Terms of Service.";
        return;
      }
      if (this.email === "") {
        this.errMsg = "Please enter your email address.";
        return;
      }
      if (!isEmailValid) {
        this.errMsg =
          "Please enter a valid email address (Example: name@domain.com)";
        return;
      }

      const contactListId = getContactListId(
        campaignCollectionSubscriptionPopupSettings
      );

      console.log({
        multiple1Id: this.multiple1Id,
        multiple1Value: this.multiple1Value,
        multiple1Overwrite: this.multiple1Overwrite,
        email: this.email,
        contactListId,
      });

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie)
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts
          console.log('eventTracking', eventTracking);
        } catch (error) {
          console.log('eventTracking error', subscribeInfoCookie);
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      };

      const apiBody = {
        email: this.email,
        contactListId,
        fields: [
          {
            id: this.multiple1Id,
            type: "multiple",
            value: this.multiple1Value,
            overwrite: this.multiple1Overwrite,
          },
        ],
        ...(eventTracking && { eventTracking }),
      };
      try {
        this.loading = true;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            // Header global settings are defined in pdp-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.showStep = "thank-you-member";
        } else {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    init() {
      console.log("alpine init");
    },
  }));
});
